import {
  type CommandProperties,
  createCommand,
  type SerializableValue,
} from '@canvas/rovo-content-bridge-api';

export interface PreviewPanelClosedMessageProperties extends CommandProperties {
  ari: string;
  product?: string;
  type?: string;
}

export const PreviewPanelClosedMessage = createCommand<
  PreviewPanelClosedMessageProperties,
  SerializableValue
>('preview-panel-closed');
